import { AnimationTriggerMetadata, animate, state, transition, style, trigger } from '@angular/animations';

export const EXPANSION_PANEL_ANIMATION_TIMING = '225ms cubic-bezier(0.4, 0.0, 0.2, 1)';

export const bllExpansionAnimations: {
	readonly bodyExpansion: AnimationTriggerMetadata;
} = {
	bodyExpansion: trigger('bodyExpansion', [
		state(
			'collapsed, void',
			style({
				height: '0px',
				visibility: 'hidden',
				overflow: 'hidden',
			})
		),
		state(
			'expanded',
			style({
				height: '*',
				visibility: 'visible',
			})
		),
		transition(':enter', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
		transition(':leave', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
		transition('* => *', animate(EXPANSION_PANEL_ANIMATION_TIMING)),
	]),
};
